var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var CONNECTOR_SANDBOX_MAX_ID = 99;
var OPEN_FINANCE_CONNECTOR_ID = 600;
function isSandboxConnector(connector) {
    return (connector.id <= CONNECTOR_SANDBOX_MAX_ID ||
        connector.id === OPEN_FINANCE_CONNECTOR_ID);
}
export function getConnectorsWithUnifiedSandbox(connectors) {
    var quantityOfSandboxConnectors = connectors.filter(function (connector) {
        return isSandboxConnector(connector);
    }).length;
    if (quantityOfSandboxConnectors <= 1) {
        // we don't need to unify sandbox connectors
        return connectors;
    }
    var firstSandboxConnectorNormalized = getFirstSandboxConnectorNormalized(connectors);
    var connectorsExceptSandbox = connectors.filter(function (connector) { return !isSandboxConnector(connector); });
    var connectorsWithSandboxNormalized = __spreadArrays([
        firstSandboxConnectorNormalized
    ], connectorsExceptSandbox);
    return connectorsWithSandboxNormalized;
}
function getFirstSandboxConnectorNormalized(connectors) {
    var firstSandboxConnector = connectors.filter(function (connector) {
        return isSandboxConnector(connector);
    })[0];
    // note: cloning connector to prevent unwanted properties overrides
    var connectorClone = __assign({}, firstSandboxConnector);
    // change connector name
    connectorClone.name = 'Sandbox';
    return connectorClone;
}
/**
 * Sort connector tabs by connectorTabsOrder prop, if specified.
 * If not specified, keep original order.
 * If specified, but not all tabs are present, keep original order for the missing tabs (place at the end).
 *
 * @param connectorTabs
 * @param connectorTabsOrder
 */
export function sortConnectorTabs(connectorTabs, connectorTabsOrder) {
    if (!connectorTabsOrder) {
        return connectorTabs;
    }
    return __spreadArrays(connectorTabs).sort(function (a, b) {
        // order by connectorTabsOrder array index order
        // if value is not present in connectorTabsOrder, it should be ordered after
        var aIndex = connectorTabsOrder.indexOf(a);
        var bIndex = connectorTabsOrder.indexOf(b);
        if (aIndex === -1 && bIndex === -1) {
            // both values are not present in connectorTabsOrder, keep original order
            return 0;
        }
        if (aIndex === -1) {
            // only a is not present in connectorTabsOrder, order b before
            return 1;
        }
        if (bIndex === -1) {
            // only b is not present in connectorTabsOrder, order a before
            return -1;
        }
        return aIndex - bIndex;
    });
}
